exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_preWrapped__2WHzi{padding:6.5pt;margin:0 0 7pt;font-size:9pt;word-break:break-all;word-wrap:break-word;background-color:#fff;border:.0625rem solid #ccc;border-radius:.125rem}", ""]);

// exports
exports.locals = {
	"preWrapped": "style_preWrapped__2WHzi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/EventDetails/style.less
// module id = 1794
// module chunks = 8